function validatePassword(password) {
  return password.length >= 8
}

export default validatePassword
